// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  USER_FRUI_PFXHTYPE_TESTS_MODAL_CHANGE,
} from './constants';

export function fruiPfxhtypeTestsModalChange(visible,message) {
  return {
    type: USER_FRUI_PFXHTYPE_TESTS_MODAL_CHANGE,
    data:{visible,message}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_FRUI_PFXHTYPE_TESTS_MODAL_CHANGE:
      return {
        ...state,
        fruiPfxhtypeTestsModalVisible:action.data.visible,
        fruiPfxhtypeTestsModalMessage:action.data.message
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/user/redux/fruiPfxhtypeTestsModalChange.js